module.exports = __webpack_public_path__ + "img/t-26439-005.60fe14c5.jpg";